import { render, staticRenderFns } from "./Totem.vue?vue&type=template&id=7179adea&scoped=true"
import script from "./Totem.vue?vue&type=script&lang=js"
export * from "./Totem.vue?vue&type=script&lang=js"
import style0 from "./Totem.vue?vue&type=style&index=0&id=7179adea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7179adea",
  null
  
)

export default component.exports